import { MODAL_SLICE_KEY } from './slice';
/**
 *
 */
export function createModalSelectors() {
    return {
        modalActionsSelector: (state) => {
            return state[MODAL_SLICE_KEY].actions;
        },
        openedModalsSelector: (state) => {
            return state[MODAL_SLICE_KEY].openedModals;
        },
        hasModalOpenedSelector: (state, modalKey) => {
            return !!state[MODAL_SLICE_KEY].openedModals.find((o) => o.id === modalKey);
        },
    };
}
